// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  name: 'dev',
  clientAppBaseURL: "http://localhost:6543/",
  allowedIps: [
    '120.72.91.106', '120.72.91.107', '120.72.91.108', '120.72.91.109', '120.72.91.110',
    '120.72.95.90', '120.72.95.91', '120.72.95.92', '120.72.95.93', '120.72.95.94',
    '122.170.105.210', '122.170.105.215', '103.94.192.143', '74.203.128.70'
  ]
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
